import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchInputModule } from '../../base/fc-search-input/fc-search-input.module';
import { FcLocationInputComponent } from './fc-location-input.component';


@NgModule({
  declarations: [
    FcLocationInputComponent
  ],
  imports: [
    FcSearchInputModule,
    TranslateModule
  ],
  exports: [
    FcLocationInputComponent
  ]
})
export class FcLocationInputModule {}
